function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n    #copernicus_logo .st0 {\r\n      clip-path: url(#SVGID_2_);\r\n      fill: url(#SVGID_3_);\r\n    }\r\n    #copernicus_logo .st1 {\r\n      clip-path: url(#SVGID_5_);\r\n      fill: #ffcd0d;\r\n    }\r\n    #copernicus_logo .st2 {\r\n      clip-path: url(#SVGID_7_);\r\n      fill: url(#SVGID_8_);\r\n    }\r\n    #copernicus_logo .st3 {\r\n      clip-path: url(#SVGID_10_);\r\n      fill: url(#SVGID_11_);\r\n    }\r\n    #copernicus_logo .st4 {\r\n      clip-path: url(#SVGID_13_);\r\n      fill: url(#SVGID_14_);\r\n    }\r\n    #copernicus_logo .st5 {\r\n      clip-path: url(#SVGID_16_);\r\n      fill: url(#SVGID_17_);\r\n    }\r\n    #copernicus_logo .st6 {\r\n      clip-path: url(#SVGID_19_);\r\n      fill: url(#SVGID_20_);\r\n    }\r\n    #copernicus_logo .st7 {\r\n      clip-path: url(#SVGID_22_);\r\n      fill: url(#SVGID_23_);\r\n    }\r\n    #copernicus_logo .st8 {\r\n      clip-path: url(#SVGID_25_);\r\n      fill: url(#SVGID_26_);\r\n    }\r\n    #copernicus_logo .st9 {\r\n      clip-path: url(#SVGID_28_);\r\n      fill: url(#SVGID_29_);\r\n    }\r\n    #copernicus_logo .st10 {\r\n      clip-path: url(#SVGID_31_);\r\n      fill: url(#SVGID_32_);\r\n    }\r\n    #copernicus_logo .st11 {\r\n      fill: #285d97;\r\n    }\r\n  ");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M137.5,297.6c0,53.9,43.2,97.5,96.6,97.5c15.4,0,29.8-3.6,42.7-10.1c0,0,0.2-0.1,0.1-0.4 c-0.1-0.2-0.4-0.1-0.4-0.1c-9.9,3.9-20.5,6-31.9,6c-48.6,0-87.9-39.9-87.9-89.1c0-49.2,39.4-89.1,87.9-89.1 c34.5,0,64.3,19.9,78.7,49.2c0,0,0.1,0.3,0.3,0.2c0.2-0.1,0.1-0.4,0.1-0.4c-14.2-36.1-49-61.4-89.8-61.4 C180.7,200.1,137.5,243.8,137.5,297.6"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 137.5,
  y: 200.1,
  className: "st0",
  width: 186.5,
  height: 195.1
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_4_",
  width: 841.9,
  height: 595.3
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M507.8,316.6c-0.9-2.2-2.2-4.1-3.8-5.8c-1.6-1.6-3.5-2.9-5.6-3.9c-2.1-0.9-4.4-1.4-6.8-1.4 c-2.4,0-4.6,0.5-6.8,1.5c-2.1,1-4,2.4-5.6,4c-0.8,0.9-1.6,1.8-2.2,2.8c0,0.1,0,0.2,0,0.4c0,12,9.8,21.8,21.8,21.8 c3.7,0,7.3-0.9,10.3-2.6l0-9.9C509.2,321.1,508.7,318.7,507.8,316.6"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_6_",
  d: "M246.3,351.5c-2.9-1.3-5.4-3-7.5-5.2c-2.1-2.2-3.8-4.8-5-7.7c-1.2-2.9-1.8-6-1.8-9.3c0-3.3,0.6-6.4,1.8-9.3 c1.2-2.9,2.9-5.5,5-7.7c2.1-2.2,4.6-3.9,7.5-5.2c2.9-1.3,5.9-1.9,9.1-1.9c3.2,0,6.2,0.6,9.1,1.9c2.9,1.3,5.4,3,7.5,5.2 c2.1,2.2,3.8,4.8,5,7.7c1.2,2.9,1.8,6,1.8,9.3c0,3.3-0.6,6.4-1.8,9.3c-1.2,2.9-2.9,5.5-5,7.7c-2.1,2.2-4.6,3.9-7.5,5.2 c-2.9,1.3-5.9,1.9-9.1,1.9C252.2,353.4,249.2,352.8,246.3,351.5 M243.2,299.6c-3.8,1.7-7.2,4-10,6.9c-2.9,2.9-5.1,6.4-6.8,10.3 c-1.6,3.9-2.5,8.1-2.5,12.6c0,4.5,0.8,8.6,2.5,12.6c1.6,3.9,3.9,7.3,6.8,10.3c2.9,2.9,6.2,5.2,10,6.9c3.8,1.7,7.9,2.5,12.3,2.5 c4.4,0,8.4-0.8,12.3-2.5c3.8-1.7,7.2-4,10-6.9c2.9-2.9,5.1-6.4,6.8-10.3c1.6-3.9,2.5-8.1,2.5-12.6c0-4.5-0.8-8.6-2.5-12.6 c-1.6-3.9-3.9-7.3-6.8-10.3c-2.9-2.9-6.2-5.2-10-6.9c-3.8-1.7-7.9-2.5-12.3-2.5C251.1,297.1,247,297.9,243.2,299.6"
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 223.9,
  y: 297.1,
  className: "st2",
  width: 63,
  height: 64.6
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_9_",
  d: "M315,351.7c-2.9-1.3-5.4-3-7.5-5.2c-2.1-2.2-3.8-4.8-5-7.7c-1.2-2.9-1.8-6-1.8-9.3c0-3.3,0.6-6.4,1.8-9.3 c1.2-2.9,2.9-5.5,5-7.7c2.1-2.2,4.6-3.9,7.5-5.2c2.9-1.3,5.9-1.9,9.1-1.9c3.2,0,6.2,0.6,9.1,1.9c2.9,1.3,5.4,3,7.5,5.2 c2.1,2.2,3.8,4.8,5,7.7c1.2,2.9,1.8,6,1.8,9.3c0,3.3-0.6,6.4-1.8,9.3c-1.2,2.9-2.9,5.5-5,7.7c-2.1,2.2-4.6,3.9-7.5,5.2 c-2.9,1.3-5.9,1.9-9.1,1.9C320.9,353.5,317.9,352.9,315,351.7 M311.9,299.7c-3.8,1.7-7.2,4-10,6.9c-2.9,2.9-5.1,6.4-6.8,10.3 c-1.6,3.9-2.5,8.1-2.5,12.6v53h8v-33.1c2.1,3.5,5.5,6.5,10.1,8.9c4.6,2.4,9,3.6,13.4,3.6c4.4,0,8.4-0.8,12.3-2.5 c3.8-1.7,7.2-4,10-6.9c2.9-2.9,5.1-6.4,6.8-10.3c1.6-3.9,2.5-8.1,2.5-12.6c0-4.5-0.8-8.6-2.5-12.6c-1.6-3.9-3.9-7.3-6.8-10.3 c-2.9-2.9-6.2-5.2-10-6.9c-3.8-1.7-7.9-2.5-12.3-2.5C319.8,297.2,315.7,298,311.9,299.7"
}));

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 292.6,
  y: 297.2,
  className: "st3",
  width: 63,
  height: 85.2
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_12_",
  d: "M375.4,312.3c2.1-2.2,4.6-3.9,7.5-5.2c2.9-1.3,5.9-1.9,9.1-1.9c3.2,0,6.2,0.6,9.1,1.9 c2.9,1.3,5.4,3,7.5,5.2c1.8,1.9,3.2,4,4.4,6.3h-42C372.1,316.3,373.6,314.2,375.4,312.3 M379.7,299.6c-3.8,1.7-7.2,4-10,6.9 c-2.9,2.9-5.1,6.4-6.8,10.3c-1.6,3.9-2.5,8.1-2.5,12.6c0,4.5,0.8,8.6,2.5,12.6c1.6,3.9,3.9,7.3,6.8,10.3c2.9,2.9,6.2,5.2,10,6.9 c3.8,1.7,7.9,2.5,12.3,2.5c4.4,0,8.4-0.8,12.3-2.5c3.8-1.7,7.2-4,10-6.9c2.9-2.9,5.1-6.4,6.7-10.3l0.3-0.9h-8.8 c-1.1,2-2.4,3.8-3.9,5.4c-2.1,2.2-4.6,3.9-7.5,5.2c-2.9,1.3-5.9,1.9-9.1,1.9c-3.2,0-6.2-0.6-9.1-1.9c-2.9-1.3-5.4-3-7.5-5.2 c-2.1-2.2-3.8-4.8-5-7.7c-1.2-2.9-1.8-6-1.8-9.3c0-0.8,0-1.6,0.1-2.5h54.8c-0.2-3.5-1-6.9-2.4-10.1c-1.6-3.9-3.8-7.3-6.7-10.3 c-2.9-2.9-6.2-5.2-10-6.9c-3.8-1.7-7.9-2.5-12.3-2.5C387.6,297.1,383.6,297.9,379.7,299.6"
}));

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 360.5,
  y: 297.1,
  className: "st4",
  width: 62.9,
  height: 64.6
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_15_",
  d: "M448.6,302.4c-3.8,1.7-7.2,4-10.1,7c-0.5,0.5-0.9,1.1-1.3,1.9v-11.2h-7.9l0.1,58.7h7.9v-26.6 c0-3.3,0.6-6.4,1.8-9.3c1.2-2.9,2.9-5.5,5-7.7c2.1-2.2,4.6-3.9,7.5-5.2c2.9-1.3,5.9-1.9,9.1-1.9v-8.2 C456.5,299.9,452.4,300.7,448.6,302.4"
}));

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 429.4,
  y: 299.9,
  className: "st5",
  width: 31.5,
  height: 58.9
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_18_",
  d: "M486.4,297.7c-1.8,0.4-3.4,1-5,1.7c-1.6,0.7-3,1.6-4.3,2.7c-1.3,1.1-2.3,2.2-3.1,3.5v-5.4h-8v58.7h8.1 l-0.1-35.2c0-2.3,0.5-4.5,1.4-6.7c1-2.2,2.2-4.1,3.8-5.8c1.6-1.7,3.5-3,5.6-4c2.1-1,4.4-1.5,6.8-1.5c2.4,0,4.6,0.5,6.8,1.4 c2.1,0.9,4,2.2,5.6,3.9c1.6,1.6,2.9,3.6,3.8,5.8c0.9,2.2,1.4,4.5,1.4,7l0.1,35.2h8.2l-0.1-35.2c0-3.6-0.7-7-2.1-10.3 c-1.4-3.2-3.2-6.1-5.6-8.5c-2.3-2.4-5.1-4.3-8.2-5.7c-3.1-1.4-6.5-2.1-10-2.1C489.9,297.1,488.1,297.3,486.4,297.7"
}));

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 466,
  y: 297.1,
  className: "st6",
  width: 51.5,
  height: 61.7
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_21_",
  d: "M525.7,358.8h8v-58.7h-8V358.8z M526.4,278.1c-0.9,0.9-1.4,2.1-1.4,3.5c0,1.4,0.5,2.6,1.4,3.5 c0.9,0.9,2.1,1.4,3.4,1.4c1.4,0,2.5-0.5,3.4-1.4c0.9-0.9,1.4-2.1,1.4-3.5c0-1.4-0.5-2.6-1.4-3.5c-0.9-0.9-2.1-1.4-3.4-1.4 C528.5,276.6,527.3,277.1,526.4,278.1"
}));

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 525,
  y: 276.6,
  className: "st7",
  width: 9.6,
  height: 82.2
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_24_",
  d: "M559.3,299.6c-3.8,1.7-7.2,4-10,6.9c-2.9,2.9-5.1,6.4-6.8,10.3c-1.6,3.9-2.5,8.1-2.5,12.6 c0,4.5,0.8,8.6,2.5,12.6c1.6,3.9,3.9,7.3,6.8,10.3c2.9,2.9,6.2,5.2,10,6.9c3.8,1.7,7.9,2.5,12.3,2.5c4.4,0,8.4-0.8,12.3-2.5 c3.8-1.7,7.2-4,10-6.9c2.9-2.9,5.1-6.4,6.7-10.3l0.3-0.9h-8.8c-1.1,2-2.4,3.8-3.9,5.4c-2.1,2.2-4.6,3.9-7.5,5.2 c-2.9,1.3-5.9,1.9-9.1,1.9c-3.2,0-6.2-0.6-9.1-1.9c-2.9-1.3-5.4-3-7.5-5.2c-2.1-2.2-3.8-4.8-5-7.7c-1.2-2.9-1.8-6-1.8-9.3 c0-3.3,0.6-6.4,1.8-9.3c1.2-2.9,2.9-5.5,5-7.7c2.1-2.2,4.6-3.9,7.5-5.2c2.9-1.3,5.9-1.9,9.1-1.9c3.2,0,6.2,0.6,9.1,1.9 c2.9,1.3,5.4,3,7.5,5.2c1.5,1.6,2.8,3.3,3.8,5.3h8.9l-0.3-0.8c-1.6-3.9-3.8-7.3-6.7-10.3c-2.9-2.9-6.2-5.2-10-6.9 c-3.8-1.7-7.9-2.5-12.3-2.5C567.2,297.1,563.1,297.9,559.3,299.6"
}));

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 540,
  y: 297.1,
  className: "st8",
  width: 60.8,
  height: 64.6
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_27_",
  d: "M649.1,300.1v32.3c0,2.5-0.5,4.9-1.4,7c-0.9,2.2-2.2,4.1-3.8,5.7c-1.6,1.6-3.5,2.9-5.6,3.8 c-2.1,0.9-4.4,1.4-6.9,1.4c-2.4,0-4.7-0.5-6.8-1.4c-2.1-0.9-4-2.2-5.6-3.8c-1.6-1.6-2.9-3.5-3.8-5.7c-0.9-2.2-1.4-4.5-1.4-7v-0.1 l-0.1-32.2h-8.2l0.1,32.2v0.1c0,3.6,0.7,7,2.1,10.2c1.4,3.2,3.2,6,5.6,8.4c2.3,2.4,5.1,4.3,8.2,5.7c3.1,1.4,6.5,2.1,10,2.1 c3.5,0,6.8-0.7,10-2.1c3.1-1.4,5.9-3.3,8.2-5.7c2.3-2.4,4.2-5.2,5.5-8.4c1.3-3.2,2-6.6,2-10.2v-32.3H649.1z"
}));

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 605.6,
  y: 300.1,
  className: "st9",
  width: 51.5,
  height: 58.7
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_30_",
  d: "M676.2,298.6c-2.5,1.1-4.7,2.4-6.5,4.1c-1.8,1.7-3.2,3.6-4.2,5.8c-1,2.2-1.3,4.6-1,7.1 c0.4,3.3,1.5,6,3.3,8.2c1.8,2.2,4,3.8,6.5,4.9c2.5,1.1,5.3,2,8.2,2.8c3,0.8,5.5,1.6,7.4,2.6c2,0.9,3.5,2.1,4.5,3.6 c1,1.5,1.5,3.6,1.4,6.2c-0.2,2.6-1.2,4.8-3,6.6c-1.9,1.8-4.7,2.8-8.5,2.8c-3.3,0.1-6-0.6-8.1-2c-2.1-1.4-3.6-3-4.4-4.8 c-0.8-1.7-1.2-3.6-1.2-5.6h-8c-0.1,3.4,0.5,6.3,1.7,8.7c1.2,2.5,2.8,4.6,4.8,6.3c2,1.8,4.3,3.1,6.9,4.1c2.6,1,5.2,1.5,7.9,1.5 c2.7,0,5.2-0.4,7.7-1.2c2.5-0.8,4.7-1.9,6.5-3.4c1.9-1.5,3.4-3.3,4.5-5.5c1.1-2.2,1.7-4.7,1.7-7.4c0-3.7-0.7-6.7-2.1-9.2 c-1.4-2.4-3.3-4.4-5.8-6c-2.5-1.6-5.1-2.9-8-3.8c-2.8-0.9-5.4-1.8-7.7-2.7c-2.3-0.9-4.2-1.8-5.6-2.8c-1.4-1-2.3-2.5-2.7-4.3 c-0.4-2.1,0.2-4.1,1.7-6c1.5-1.9,3.1-3.1,4.9-3.8c1.8-0.6,3.4-0.9,4.9-0.9c2.3,0,4.4,0.6,6.3,1.8c1.9,1.2,3.2,3,3.9,5.2h8.6 c-0.2-1.2-0.7-2.6-1.5-4.2c-0.9-1.6-2.1-3.3-3.6-4.9c-1.5-1.6-3.4-2.9-5.7-3.9c-2.3-1-4.9-1.5-8-1.5 C681.3,297.1,678.8,297.6,676.2,298.6"
}));

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 662.8,
  y: 297.1,
  className: "st10",
  width: 41.7,
  height: 64.6
});

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_33_",
  width: 841.9,
  height: 595.3
}));

var _ref26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M387.4,387.4h-9.4v8.7h10.5v2.6h-13.7v-24.3H388v2.6h-10v7.7h9.4V387.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M406.8,394c0,1.8,0,3.4,0.1,4.8h-2.8l-0.2-2.8h-0.1c-0.8,1.4-2.7,3.2-5.8,3.2c-2.7,0-6-1.5-6-7.6v-10.2h3.2 v9.6c0,3.3,1,5.6,3.9,5.6c2.1,0,3.6-1.5,4.2-2.9c0.2-0.4,0.3-1,0.3-1.6v-10.7h3.2V394z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M412.1,386.8c0-2.1,0-3.8-0.1-5.4h2.8l0.1,3.5h0.1c0.8-2.3,2.7-3.8,4.9-3.8c0.3,0,0.6,0,0.9,0.1v3 c-0.3-0.1-0.6-0.1-1.1-0.1c-2.2,0-3.8,1.7-4.2,4c-0.1,0.4-0.1,1-0.1,1.5v9.3h-3.2V386.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M439.3,389.9c0,6.4-4.5,9.3-8.7,9.3c-4.7,0-8.4-3.5-8.4-9c0-5.8,3.9-9.2,8.6-9.2 C435.9,381,439.3,384.6,439.3,389.9z M425.5,390.1c0,3.8,2.2,6.7,5.3,6.7c3,0,5.3-2.8,5.3-6.8c0-3-1.5-6.7-5.2-6.7 C427.1,383.4,425.5,386.8,425.5,390.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M443.3,387c0-2.2-0.1-4-0.1-5.7h2.8l0.2,3h0.1c1.3-2.1,3.3-3.3,6.2-3.3c4.2,0,7.4,3.6,7.4,8.8 c0,6.3-3.9,9.4-8,9.4c-2.3,0-4.3-1-5.4-2.7h-0.1v9.5h-3.1V387z M446.4,391.7c0,0.5,0,0.9,0.1,1.3c0.6,2.2,2.5,3.7,4.8,3.7 c3.3,0,5.3-2.7,5.3-6.7c0-3.5-1.8-6.4-5.2-6.4c-2.2,0-4.2,1.5-4.8,3.9c-0.1,0.4-0.2,0.9-0.2,1.3V391.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M465.5,390.6c0.1,4.3,2.8,6,6,6c2.3,0,3.7-0.4,4.8-0.9l0.6,2.3c-1.1,0.5-3.1,1.1-5.8,1.1 c-5.4,0-8.6-3.6-8.6-8.8c0-5.3,3.1-9.4,8.2-9.4c5.7,0,7.2,5,7.2,8.2c0,0.6,0,1.1-0.1,1.5H465.5z M474.8,388.4c0-2-0.8-5.1-4.4-5.1 c-3.2,0-4.6,2.9-4.9,5.1H474.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M484.9,373.9c-0.8,3-2.4,6.9-3.3,8.6l-2,0.2c0.8-2.1,1.7-5.8,2.1-8.4L484.9,373.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M485.3,395.6c1,0.6,2.6,1.2,4.2,1.2c2.3,0,3.3-1.1,3.3-2.6c0-1.5-0.9-2.3-3.2-3.2c-3.2-1.2-4.6-2.8-4.6-4.9 c0-2.8,2.3-5.1,6-5.1c1.8,0,3.3,0.5,4.2,1.1l-0.8,2.3c-0.7-0.4-1.9-1-3.6-1c-1.9,0-2.9,1.1-2.9,2.4c0,1.4,1,2.1,3.3,3 c3,1.1,4.6,2.6,4.6,5.2c0,3.1-2.4,5.3-6.5,5.3c-1.9,0-3.7-0.5-4.9-1.2L485.3,395.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M509.4,390.6c0.1,4.3,2.8,6,6,6c2.3,0,3.7-0.4,4.8-0.9l0.6,2.3c-1.1,0.5-3.1,1.1-5.8,1.1 c-5.4,0-8.6-3.6-8.6-8.8c0-5.3,3.1-9.4,8.2-9.4c5.7,0,7.2,5,7.2,8.2c0,0.6,0,1.1-0.1,1.5H509.4z M518.7,388.4c0-2-0.8-5.1-4.4-5.1 c-3.2,0-4.6,2.9-4.9,5.1H518.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M526.8,381.4l3.8,10.3c0.4,1.2,0.9,2.5,1.2,3.6h0.1c0.3-1,0.7-2.4,1.1-3.6l3.5-10.2h3.3l-4.8,12.4 c-2.3,6-3.8,9-6,10.9c-1.6,1.3-3.1,1.9-3.9,2l-0.8-2.6c0.8-0.3,1.8-0.8,2.8-1.5c0.9-0.7,1.9-1.9,2.7-3.5c0.1-0.3,0.3-0.6,0.3-0.8 c0-0.2-0.1-0.4-0.3-0.8l-6.4-16.1H526.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M544,390.6c0.1,4.3,2.8,6,6,6c2.3,0,3.7-0.4,4.8-0.9l0.6,2.3c-1.1,0.5-3.1,1.1-5.8,1.1 c-5.4,0-8.6-3.6-8.6-8.8c0-5.3,3.1-9.4,8.2-9.4c5.7,0,7.2,5,7.2,8.2c0,0.6,0,1.1-0.1,1.5H544z M553.3,388.4c0-2-0.8-5.1-4.4-5.1 c-3.2,0-4.6,2.9-4.9,5.1H553.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M559.9,395.6c1,0.6,2.6,1.2,4.2,1.2c2.3,0,3.3-1.1,3.3-2.6c0-1.5-0.9-2.3-3.2-3.2c-3.2-1.2-4.6-2.8-4.6-4.9 c0-2.8,2.3-5.1,6-5.1c1.8,0,3.3,0.5,4.2,1.1l-0.8,2.3c-0.7-0.4-1.9-1-3.6-1c-1.9,0-2.9,1.1-2.9,2.4c0,1.4,1,2.1,3.3,3 c3,1.1,4.6,2.6,4.6,5.2c0,3.1-2.4,5.3-6.5,5.3c-1.9,0-3.7-0.5-4.9-1.2L559.9,395.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M598,389.9c0,6.4-4.5,9.3-8.7,9.3c-4.7,0-8.4-3.5-8.4-9c0-5.8,3.9-9.2,8.6-9.2C594.6,381,598,384.6,598,389.9 z M584.2,390.1c0,3.8,2.2,6.7,5.3,6.7c3,0,5.3-2.8,5.3-6.8c0-3-1.5-6.7-5.2-6.7C585.8,383.4,584.2,386.8,584.2,390.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M602,386.1c0-1.8,0-3.3-0.1-4.7h2.8l0.2,2.9h0.1c0.9-1.6,2.9-3.2,5.8-3.2c2.4,0,6.2,1.4,6.2,7.4v10.4h-3.2 v-10c0-2.8-1-5.1-4-5.1c-2.1,0-3.7,1.5-4.2,3.2c-0.1,0.4-0.2,0.9-0.2,1.5v10.5H602V386.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M642.2,387.4h-9.4v8.7h10.5v2.6h-13.7v-24.3h13.1v2.6h-10v7.7h9.4V387.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M659.5,394.6c0,1.5,0.1,3,0.3,4.2h-2.8l-0.3-2.2h-0.1c-1,1.4-2.8,2.6-5.3,2.6c-3.5,0-5.3-2.5-5.3-5 c0-4.2,3.7-6.5,10.5-6.5v-0.4c0-1.4-0.4-4-4-4c-1.7,0-3.3,0.5-4.6,1.3l-0.7-2.1c1.4-0.9,3.6-1.5,5.8-1.5c5.3,0,6.6,3.6,6.6,7.1 V394.6z M656.5,389.9c-3.5-0.1-7.4,0.5-7.4,3.9c0,2.1,1.4,3,3,3c2.3,0,3.8-1.4,4.3-2.9c0.1-0.4,0.1-0.7,0.1-1V389.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M664.6,386.8c0-2.1,0-3.8-0.1-5.4h2.8l0.1,3.5h0.1c0.8-2.3,2.7-3.8,4.9-3.8c0.3,0,0.6,0,0.9,0.1v3 c-0.3-0.1-0.6-0.1-1.1-0.1c-2.2,0-3.8,1.7-4.2,4c-0.1,0.4-0.1,1-0.1,1.5v9.3h-3.2V386.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M681.1,377.2v4.2h4.5v2.4h-4.5v9.4c0,2.2,0.6,3.4,2.4,3.4c0.9,0,1.4-0.1,1.8-0.2l0.1,2.4 c-0.6,0.2-1.6,0.4-2.8,0.4c-1.5,0-2.7-0.5-3.4-1.3c-0.9-1-1.2-2.5-1.2-4.6v-9.5h-2.7v-2.4h2.7v-3.2L681.1,377.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M689.2,373.2h3.2v10.9h0.1c0.5-0.9,1.3-1.7,2.3-2.3c0.9-0.5,2.1-0.9,3.2-0.9c2.3,0,6.1,1.4,6.1,7.4v10.4h-3.2 v-10c0-2.8-1-5.1-4-5.1c-2.1,0-3.6,1.4-4.2,3.1c-0.2,0.5-0.2,0.9-0.2,1.5v10.5h-3.2V373.2z"
}));

var SvgCopernicusLogo = function SvgCopernicusLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copernicus_logo",
    x: "0px",
    y: "0px",
    viewBox: "100 200 650.9 200",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.002081109,
    y1: 595.2774,
    x2: 1.0021,
    y2: 595.2774,
    gradientTransform: "matrix(0 -195.0859 -195.0859 0 116360.9609 395.5871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#226295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#78aedf"
    }
  })), _ref4), /*#__PURE__*/React.createElement("g", null, _ref5, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _ref6), /*#__PURE__*/React.createElement("g", null, _ref7, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00203372,
    y1: 595.2748,
    x2: 1.002,
    y2: 595.2748,
    gradientTransform: "matrix(0 -64.5586 -64.5586 0 38685.5508 361.7587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref8), /*#__PURE__*/React.createElement("g", null, _ref9, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.004009415,
    y1: 595.2798,
    x2: 1.004,
    y2: 595.2798,
    gradientTransform: "matrix(0 -85.248 -85.248 0 51070.5547 382.7759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref10), /*#__PURE__*/React.createElement("g", null, _ref11, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00203372,
    y1: 595.2748,
    x2: 1.002,
    y2: 595.2748,
    gradientTransform: "matrix(0 -64.5586 -64.5586 0 38822.0508 361.7587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref12), /*#__PURE__*/React.createElement("g", null, _ref13, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.0007516916,
    y1: 595.2726,
    x2: 1.0007,
    y2: 595.2726,
    gradientTransform: "matrix(0 -58.9258 -58.9258 0 35522.0352 358.8553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref14), /*#__PURE__*/React.createElement("g", null, _ref15, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.001157944,
    y1: 595.2734,
    x2: 1.0012,
    y2: 595.2734,
    gradientTransform: "matrix(0 -61.7422 -61.7422 0 37245.25 358.8825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref16), /*#__PURE__*/React.createElement("g", null, _ref17, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.0009845195,
    y1: 595.2773,
    x2: 1.001,
    y2: 595.2773,
    gradientTransform: "matrix(0 -82.166 -82.166 0 49441.3906 358.8919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref18), /*#__PURE__*/React.createElement("g", null, _ref19, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_25_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_24_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00203372,
    y1: 595.2745,
    x2: 1.002,
    y2: 595.2745,
    gradientTransform: "matrix(0 -64.5586 -64.5586 0 39000.5508 361.7587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref20), /*#__PURE__*/React.createElement("g", null, _ref21, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.004806754,
    y1: 595.2723,
    x2: 0.9952,
    y2: 595.2723,
    gradientTransform: "matrix(0 -58.6895 -58.6895 0 35567.6172 358.5289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref22), /*#__PURE__*/React.createElement("g", null, _ref23, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00203372,
    y1: 595.2754,
    x2: 1.002,
    y2: 595.2754,
    gradientTransform: "matrix(0 -64.5586 -64.5586 0 39113.7266 361.7587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19294b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#284491"
    }
  })), _ref24), /*#__PURE__*/React.createElement("g", null, _ref25, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  }))), _ref26);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopernicusLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copernicus_logo.46c156cf.svg";
export { ForwardRef as ReactComponent };